import React, { Fragment, useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { LoadingComponent } from 'recupero-comunes'
import { configuracionFormAction39, obtenerComboInstanciaPretensiones, obtenerComboPosibilidadAcuerdo, obtenerPretensionesVigentes, obtenerComboMonedas} from '../../../../store/actions/gestion-defensa-action'
import Pretensiones from './pretensiones'
import GrillaImplicadosHistorial from './grillaImplicadosHistorial'
import { Auth } from 'recupero-comunes';

const PretensionesModal = ({ showPretensiones, handleClosePretensiones, showImplicados, setShowImplicados, showImplicadosHistorial, setShowImplicadosHistorial }) => {
  const [loading, setLoading] = useState(false);
  const data_gestion_defensa = useSelector((state) => state.gestionDefensaReducer);
  const { llaves, datosGestionImplicado } = data_gestion_defensa;
  const dispatch = useDispatch();

  useEffect(() => {
    if (llaves && datosGestionImplicado) {
      setLoading(true)
      let query = Buffer.from(JSON.stringify({ rutcia: llaves && llaves['idOrgCaso'], idform: 39 })).toString('base64')

      dispatch(configuracionFormAction39(query));

      const paisOrganizacion = Auth.currentUser().paisOrganizacion;
      const codClasCaso = datosGestionImplicado.datosGestionImplicado && datosGestionImplicado.datosGestionImplicado.length > 0 && datosGestionImplicado.datosGestionImplicado[0].codClasCaso;
      const query_one = Buffer.from(JSON.stringify({ pais: paisOrganizacion, clasBien: codClasCaso })).toString('base64');
      dispatch(obtenerComboMonedas(query_one))
        .then(() => {
          let query = Buffer.from(JSON.stringify({ concepto: 258 })).toString('base64')
          dispatch(obtenerComboInstanciaPretensiones(query))
        })
        .then(() => {
          let query = Buffer.from(JSON.stringify({ concepto: 259 })).toString('base64')
          dispatch(obtenerComboPosibilidadAcuerdo(query))
        })
        .then(() => {
          let query = Buffer.from(JSON.stringify({
            idCaso: llaves && llaves['idCaso'],
            idImplicado: llaves && llaves['idImplicado'],
            tipoGestion: datosGestionImplicado.datosGestionImplicado && datosGestionImplicado.datosGestionImplicado.length > 0 && datosGestionImplicado.datosGestionImplicado[0].codTipoGestion,
            tipoMovimiento: 261001,
            situacion: 245002
          })).toString('base64')
          
          dispatch(obtenerPretensionesVigentes(query))
        })
        .then(() => { setLoading(false) })
    }
  }, [dispatch, showPretensiones])

  return (
    <>
      <LoadingComponent show={loading} />
      <Modal show={showPretensiones} onHide={handleClosePretensiones} size='xl'>
        <Pretensiones handleClose={handleClosePretensiones}
          idCaso={llaves && llaves['idCaso']}
          idImplicado={llaves && llaves['idImplicado']}
          idOrganizacionCaso={llaves && llaves['idOrgCaso']}
          setShowImplicados={setShowImplicados}
          setShowImplicadosHistorial={setShowImplicadosHistorial}
        />
        {showImplicadosHistorial && <GrillaImplicadosHistorial />}
      </Modal>
    </>
  )
}

export default PretensionesModal
